import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthBackground from '../../components/AuthBackground';
import ScreenContainer from '../../components/ScreenContainer';
import TopBar from '../../components/TopBar';
import Heading from '../../components/Heading';
import Text from '../../components/Text';
import Button from '../../components/Button';

const PasswordResetConfirm = () => {
  const navigate = useNavigate();

  return (
    <>
      <AuthBackground />
      <ScreenContainer>
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <TopBar 
            title="Password Reset" 
            onBack={() => navigate('/auth/verify-code')}
          />
          <div className="text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
              </svg>
            </div>
            <Heading size="lg" className="mb-3">Password Reset</Heading>
            <Text>Your password has been successfully reset. Click confirm to set a new password.</Text>
          </div>
          <Button 
            fullWidth
            onClick={() => navigate('/auth/new-password')}
            className="mt-8"
          >
            Confirm
          </Button>
        </div>
      </ScreenContainer>
    </>
  );
};

export default PasswordResetConfirm;